// src/components/OrganizationManagement/OrganizationBadges.js
import React from 'react';
import PropTypes from 'prop-types';
import './OrganizationBadges.css';

/**
 * Organization status badges component
 * 
 * Displays authorization status and current organization indicator
 * 
 * @param {Object} props
 * @param {string} props.authzStatus - Authorization status: "AUTHORIZED" or "NOT_AUTHORIZED"
 * @param {boolean} props.isCurrent - Whether this is the currently selected organization
 */
const OrganizationBadges = ({ authzStatus, isCurrent }) => {
  const isAuthorized = authzStatus === 'AUTHORIZED';
  
  const authzTitle = isAuthorized
    ? 'Romanworks integration authorized for webhook events and M2M token API access'
    : 'Romanworks integration not authorized for webhook events and M2M token API access. This organization will not behave properly until authorized. If authorization fails, please contact Allegion Developer Support.';
  
  const authzText = isAuthorized ? '✓ Authorized' : '⚠ Not Authorized';
  const authzClass = isAuthorized ? 'authorized' : 'not-authorized';

  return (
    <div className="org-badges-row">
      <span
        className={`authz-badge ${authzClass}`}
        title={authzTitle}
      >
        {authzText}
      </span>
      {isCurrent && (
        <span className="current-badge">
          Current
        </span>
      )}
    </div>
  );
};

OrganizationBadges.propTypes = {
  authzStatus: PropTypes.oneOf(['AUTHORIZED', 'NOT_AUTHORIZED']).isRequired,
  isCurrent: PropTypes.bool,
};

OrganizationBadges.defaultProps = {
  isCurrent: false,
};

export default OrganizationBadges;
